/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './callback.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../utilities/components/centered-spinner/centered-spinner.component.ngfactory';
import * as i3 from '../../../../../../app/modules/utilities/components/centered-spinner/centered-spinner.component';
import * as i4 from '../../../../../../app/modules/user/components/callback/callback.component';
import * as i5 from '../../../../../../app/modules/user/services/auth/auth.service';
import * as i6 from '@angular/router';
const styles_CallbackComponent:any[] = [i0.styles];
export const RenderType_CallbackComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CallbackComponent,data:{}});
export function View_CallbackComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-centered-spinner',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_CenteredSpinnerComponent_0,
      i2.RenderType_CenteredSpinnerComponent)),i1.ɵdid(1,49152,(null as any),0,i3.CenteredSpinnerComponent,
      ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n']))],(null as any),(null as any));
}
export function View_CallbackComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-callback',
      ([] as any[]),(null as any),(null as any),(null as any),View_CallbackComponent_0,
      RenderType_CallbackComponent)),i1.ɵdid(1,114688,(null as any),0,i4.CallbackComponent,
      [i5.AuthService,i6.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CallbackComponentNgFactory:i1.ComponentFactory<i4.CallbackComponent> = i1.ɵccf('app-callback',
    i4.CallbackComponent,View_CallbackComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3VzZXIvY29tcG9uZW50cy9jYWxsYmFjay9jYWxsYmFjay5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9kbmF0YS1jZXJmLWZyb250LWVuZC9yZWxlYXNlcy8yMDIwMDMyNjE2MTIzMy9zcmMvYXBwL21vZHVsZXMvdXNlci9jb21wb25lbnRzL2NhbGxiYWNrL2NhbGxiYWNrLmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3VzZXIvY29tcG9uZW50cy9jYWxsYmFjay9jYWxsYmFjay5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3VzZXIvY29tcG9uZW50cy9jYWxsYmFjay9jYWxsYmFjay5jb21wb25lbnQudHMuQ2FsbGJhY2tDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLWNlbnRlcmVkLXNwaW5uZXI+PC9hcHAtY2VudGVyZWQtc3Bpbm5lcj5cbiIsIjxhcHAtY2FsbGJhY2s+PC9hcHAtY2FsbGJhY2s+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBOzRDQUFBLFVBQUE7TUFBQSwyQ0FBNkM7TUFBQTs7O29CQ0E3QztNQUFBO2tDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/user/components/callback/callback.component.ngfactory.ts